import React from 'react';
import Box from '@mui/material/Box';
import MaskTextInput from '../../../../components/MaskTextInput';
import CustomButton from '../../../../components/CustomButton';
import { RegisterPage, MaskTypes } from '../../../../utils/models';

const PhoneNumberVerification = ({
  phoneNumber,
  setPhoneNumber,
  setViewMode,
  generateOTP,
}: any) => {

  return (
    <>
      <Box component="p" m={1} className='description'>
        Enter your phone number and we will send you a one-time verification
        code to log in.
      </Box>
      <MaskTextInput
        variant='outlined'
        name='phoneNumber'
        label={'Phone Number'}
        value={phoneNumber}
        maskType={MaskTypes.PhoneNo}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setPhoneNumber(e.target.value)
        }
      />
      <CustomButton
        variant="contained"
        disableElevation={true}
        label={'send code'}
        onClick={() => generateOTP()}
        style={{ marginTop: 40 }}
      />
      <CustomButton
        variant="outlined"
        disableElevation={false}
        label={'back'}
        onClick={() => setViewMode(RegisterPage.SignUp)}
      />
    </>
  );
};

export default PhoneNumberVerification;
